(() => {
  document.querySelectorAll('[data-collar-page]').forEach(root => {
    const variants=JSON.parse(root.querySelector('[data-collar-page-variants]').textContent).variants;
    const select=root.querySelector('[data-collar-page-select]');
    const update=()=>{
      const v=variants.find(v=>String(v.id)===select.value);
      if(!v)return;
      const image=root.querySelector('[data-collar-page-image]');
      image.src=v.image;image.alt=v.title+' collar and holder; finder tag sold separately';
      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url);
      root.querySelector('[type="submit"]').disabled=!v.available;
    };
    select.addEventListener('change',update);
    root.querySelectorAll('[data-collar-photo-choice]').forEach(button=>button.addEventListener('click',()=>{
      select.value=button.dataset.collarPhotoChoice;select.dispatchEvent(new Event('change',{bubbles:true}));
      select.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }));
    update();
  });
})();
